/*global google */
import {
  mapMarker,
  mapMarkerSimple,
} from '../../../../components/maps/mapMarkers';
import { WINDOW_COLORS } from '../../utils/bundleDraft';

export function mapIconColor(
  text: string,
  fillColor: string,
  color: string,
  fillNumber: number
): google.maps.ReadonlyIcon {
  const imageUrl = mapMarker(
    color,
    text,
    fillNumber ? fillNumber : 0,
    fillColor
  );
  return {
    url: imageUrl,
    // Just place the circle over the point for now.
    //anchor: new google.maps.Point(14, 42),
    //labelOrigin: new google.maps.Point(14, 16),
  };
}

export function mapIconRoute(
  text: string,
  fillColor: string,
  color: string
): google.maps.ReadonlyIcon {
  const imageUrl = mapMarkerSimple(color, text, fillColor);
  return {
    url: imageUrl,
  };
}

export function createGroupColors(groups: string[]): Map<string, string> {
  const uniqueGroups: string[] = Array.from(new Set(groups)).sort();
  return uniqueGroups.reduce((groupMap, currentGroup) => {
    const hash = currentGroup
      .split('')
      .map(letter => letter.charCodeAt(0))
      .reduce((hash: number, currentLetter: number) => {
        let newHash = (hash << 5) - hash + currentLetter;
        newHash |= 0;
        return Math.abs(newHash);
      }, 0);

    groupMap.set(currentGroup, WINDOW_COLORS[hash % WINDOW_COLORS.length]);
    return groupMap;
  }, new Map());
}
